import { SxProps } from "@mui/material";

export const sxBreadCrumbs: SxProps = {
  fontFamily: "Montserrat-Regular",
  fontSize: "var(--font-size-xs)",
  display: "flex",
  justifyContent: "center",
  ".MuiBreadcrumbs-ol": {
    gap: "8px"
  }
}